/* eslint-disable no-undef */
/**
 * All firebase dependencies and initialization is invoked here.
 */

import firebase from "firebase";
// Add the Performance Monitoring library
import "firebase/performance";
import "firebase/analytics";
import "firebase/storage";
// import { REFRESH_INTERVAL } from "config/CONSTANTS";

console.log("ENV_NODE_ENVIRONMENT=====", process.env.NODE_ENV);
console.log("ENV_FS_DB_ENVIRONMENT=====", process.env.REACT_APP_ENV);
console.log("ENV_FS_DB_PROJECT=====", process.env.REACT_APP_FB_PROJECT_ID);
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FB_DATABASE_URL,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Initialize Performance Monitoring and get a reference to the service
const perf = firebase.performance();

// Analytics
export const analytics = firebase.analytics();

// Auth
export const fbAuth = firebase.auth();

// Storage
export const storageRef = firebase
  .app()
  .storage(process.env.REACT_APP_FB_STORAGE_IMTIME)
  .ref();

  //file Upload  
  export const storageRefUpload = firebase
  .app()
  .storage(process.env.REACT_APP_FB_UPLOAD_IMTIME)
  .ref();

  export const storageGlobalRefUpload = firebase
  .app()
  .storage(process.env.REACT_APP_FB_GLOBALUPLOAD_IMTIME)
  .ref();

  export const storageImwarehouseRefUpload = firebase
  .app()
  .storage(process.env.REACT_APP_FB_STORAGE_IMWAREHOUSE)
  .ref();
  
// Remote Config
// export const remoteConfig = firebase.remoteConfig();
// remoteConfig.settings.minimumFetchIntervalMillis = 10000;
// const REFRESH_DEFAULT = "default";
// remoteConfig.defaultConfig = {
//   "version": REFRESH_DEFAULT,
//   "region": '{"SKP":["AMER", "EURO"],"AT":["AMER", "EURO"],"SB":["IMNA", "IME", "IMAU", "IMLA"]}',
//   "imWarehouseCountries" : '["United States of America"]',
//   "punchAccess": '["demoCountry"]'
// };
// remoteConfig.fetchAndActivate();
// let oldVer = remoteConfig.getValue("version")._value;
// let region = remoteConfig.getValue("region").asString();
// let countries = remoteConfig.getValue("imWarehouseCountries").asString();
// let punchCountries = remoteConfig.getValue("punchAccess").asString();
// setInterval(()=>{
//   remoteConfig.fetchAndActivate()
//   .then(() => {
//     let newVer = remoteConfig.getValue("version")._value;
//     oldVer = oldVer===REFRESH_DEFAULT?newVer:oldVer;
//     console.log(`Version check: old=${oldVer}, new=${newVer} at ${new Date()}.`);
//     if(oldVer !== newVer && oldVer !== REFRESH_DEFAULT){
//       oldVer = newVer;
//       document.querySelector(".imtime-refresh").style.display = 'block';
//     }
//   })
//   .catch((err) => {
//     // Ignore silently
//     console.log("Err in fetchAndActivate version=", remoteConfig.getValue("version")._value);
//   });
// }, REFRESH_INTERVAL);

// export const getRcArrayParam = (param) => {
//   let result = remoteConfig.getValue(param).asString();
//   try{
//     result = JSON.parse(result);
//   } catch (err){
//     console.log("Error in firebase > getRcArrayParam=",err);
//     result = [];
//   }
//   console.log("RC result for getRcArrayParam=",result);
//   return result;
// };

// export const getWarehouseRegions = () => {
//   let result = remoteConfig.getValue("region").asString();
//   try{
//     result = JSON.parse(result);
//   } catch (err){
//     console.log("Error in firebase > getWarehouseRegions=",err);
//     result = {};
//   }
//   console.log("RC result for getWarehouseRegions=",result);
//   return result;
// };
// Remote Config END

// Firestore
export const db = firebase.firestore(); // Not recommended to use db directly in logic to have all the collection names in one place.

// Collection constants
export const CL_WORKERS = "workers";
export const CL_PUNCHES = "punches";
export const CL_JOB_FAMILIES = "jobFamilies";
export const CL_ACTIVITY_GROUPS = "activityGroups";
export const CL_LOCATIONS = "locations";
export const CL_COUNTRIES = "countries";
export const CL_EXCEPTIONS = "exceptions";
export const ASC = "asc";

export const workersRef = () => {
  return db.collection("workers");
};

export const punchesRef = () => {
  return db.collection("punches");
};

export const timesheetsRef = () => {
  return db.collection("timesheets");
};

export const countriesRef = () => {
  return db.collection("countries");
};

export const warehouseprojectRef = () => {
  return db.collection("imWarehouseProjects");
};

export const collectionRef = (collection) => {
  return db.collection(collection);
};

export const collectionGroup = (collection) => {
  return db.collectionGroup(collection);
};

// Firestore END

/*
// WARNING: Never commit this script. Use it only locally.
// ONE TIME MANUAL UPDATES HERE - NOT TO DEPLOY.
// USE LOCALLY ONLY WHEN NECESSARY TO UPDATE SOMETHING ON PROD.
const updateMe = () => {
  console.log(":::::ONE TIME MANUAL UPDATE BEGAN...");
  
  // // USE THIS LOGIC TO LOOP THROUGH A SMALL NUMBER OF SPECIFIC DOCUMENTS USING IDs
  // // Change worker docs in prod. ['1000114','1000115','1000116','1000117','1000118','1000131','1000152','1000150','1000149','9101036','9101034']
  // const querySnapshot = ['9101034','9101036'];
  // querySnapshot.forEach(async function (doc) {
  //   var country = "testCountry";
  //   var managerId = "1000118";
  //   db.doc(`workers/${doc}`).update({ country, managerId })
  //     .then((res) => console.log("::::: updated===", res))
  //     .catch((res) => console.log("::::: error catch===", res))
  // });

  // db.collection("workers")
  //   .get()
  //   .then(function (querySnapshot) {
  //     console.log("SSS:: TOTAL NUMBER OF WORKERS=",querySnapshot.size);
  //     let totalChanges = 0;
  //     querySnapshot.forEach(function (doc) {
  //       var item = doc.data();

  //       // 09apr21: temp + isManager = isApprover:true
  //       if (item.isManager && item.workerType == "temp") {
  //         console.log("SSS::",item);
  //         // doc.ref.update({
  //         //   isApprover: true,
  //         // });
  //         totalChanges++;
  //       }

  //     });
  //     console.log(":::::TOTAL RECORDS UPDATED=",totalChanges);
  //   })
  //   .catch(err=> console.log("Error in services-firebase ONE TIME MANUAL UPDATE!"))

};
updateMe();
// ONE TIME MANUAL UPDATES HERE - END
*/
